import { render, staticRenderFns } from "./SpecialDay.vue?vue&type=template&id=33fce582&scoped=true&"
import script from "./SpecialDay.vue?vue&type=script&lang=js&"
export * from "./SpecialDay.vue?vue&type=script&lang=js&"
import style0 from "./SpecialDay.vue?vue&type=style&index=0&id=33fce582&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fce582",
  null
  
)

export default component.exports